export const languages = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇵🇹" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
  { code: "pl", name: "Polski", flag: "🇵🇱" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "zh", name: "中文", flag: "🇨🇳" },
  { code: "hi", name: "हिन्दी", flag: "🇮🇳" },
  { code: "th", name: "ไทย", flag: "🇹🇭" },
  { code: "vi", name: "Tiếng Việt", flag: "🇻🇳" },
  { code: "id", name: "Indonesia", flag: "🇮🇩" },
  { code: "ja", name: "日本語", flag: "🇯🇵" },
  { code: "bs", name: "Bosanski", flag: "🇧🇦" },
  { code: "hu", name: "Magyar", flag: "🇭🇺" },
  { code: "hr", name: "Hrvatski", flag: "🇭🇷" },
  { code: "sr", name: "Srpski", flag: "🇷🇸" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "ro", name: "Română", flag: "🇷🇴" },
] as const;

export type LangCode = typeof languages[number]["code"];

export type TranslationKeys = {
  selectLanguage: string;
  nextLevel: string;
  marketIntelligence: string;
  heroSubtitle: string;
  startTradingNow: string;
  founderCeo: string;
  felixBio1: string;
  felixBio2: string;
  felixBio3: string;
  felixQuote: string;
  fullPresentation: string;
  presentationSubtitle: string;
  softwareTitle: string;
  softwareSubtitle: string;
  marketingTitle: string;
  marketingSubtitle: string;
  watchNow: string;
  ctaTitle: string;
  enrollNow: string;
  stillNotReady: string;
  shootMessage: string;
  advancedAi: string;
  quoteText: string;
  riskDisclaimer: string;
};

export const translations: Record<LangCode, TranslationKeys> = {
  en: {
    selectLanguage: "Select your language to start",
    nextLevel: "Next Level",
    marketIntelligence: "Market Intelligence",
    heroSubtitle: "Building a more transparent and prosperous tomorrow in the crypto space.",
    startTradingNow: "Start Trading Now",
    founderCeo: "Founder & CEO",
    felixBio1: "Born in Hamburg, Germany, Felix began his career in private banking, where he developed a passion for international trade.",
    felixBio2: "Eventually, his fascination with patterns and efficiency, combined with his interest in crypto, led him and his team to start developing algorithmic trading software.",
    felixBio3: "Today the Polar One software has been successful for nearly four years!",
    felixQuote: "\"We're a company doing things right!\"",
    fullPresentation: "Full Presentation",
    presentationSubtitle: "Complete overview of our platform and technology",
    softwareTitle: "Polar One Software & Performance",
    softwareSubtitle: "Watch how our AI trading system performs",
    marketingTitle: "Marketing & Rewards Plan",
    marketingSubtitle: "Discover how you can grow with Polar Tensor",
    watchNow: "Watch Now",
    ctaTitle: "Get Started With Polar Tensor Today",
    enrollNow: "Enroll Now",
    stillNotReady: "Still Not Ready To Enroll?",
    shootMessage: "Shoot me a message and I'll get all of your questions answered.",
    advancedAi: "Advanced AI Crypto Intelligence",
    quoteText: "For the average, everyday person, looking for modern ways to accelerate their wealth!",
    riskDisclaimer: "The crypto market involves significant risks, and is not suitable for everyone. By engaging with Polar Tensor, you understand these risks and there are no guarantees offered of any kind. You are responsible for your own due diligence and participation level.",
  },
  de: {
    selectLanguage: "Wählen Sie Ihre Sprache",
    nextLevel: "Nächstes Level",
    marketIntelligence: "Marktintelligenz",
    heroSubtitle: "Wir bauen ein transparenteres und wohlhabenderes Morgen im Kryptobereich.",
    startTradingNow: "Jetzt Handeln",
    founderCeo: "Gründer & CEO",
    felixBio1: "Felix wurde in Hamburg, Deutschland, geboren und begann seine Karriere im Private Banking, wo er eine Leidenschaft für internationalen Handel entwickelte.",
    felixBio2: "Schließlich führten seine Faszination für Muster und Effizienz, kombiniert mit seinem Interesse an Krypto, dazu, dass er und sein Team mit der Entwicklung algorithmischer Handelssoftware begannen.",
    felixBio3: "Heute ist die Polar One Software seit fast vier Jahren erfolgreich!",
    felixQuote: "\"Wir sind ein Unternehmen, das die Dinge richtig macht!\"",
    fullPresentation: "Vollständige Präsentation",
    presentationSubtitle: "Kompletter Überblick über unsere Plattform und Technologie",
    softwareTitle: "Polar One Software & Leistung",
    softwareSubtitle: "Sehen Sie, wie unser KI-Handelssystem funktioniert",
    marketingTitle: "Marketing & Belohnungsplan",
    marketingSubtitle: "Entdecken Sie, wie Sie mit Polar Tensor wachsen können",
    watchNow: "Jetzt Ansehen",
    ctaTitle: "Starten Sie heute mit Polar Tensor",
    enrollNow: "Jetzt Einschreiben",
    stillNotReady: "Noch nicht bereit sich einzuschreiben?",
    shootMessage: "Schreiben Sie mir eine Nachricht und ich beantworte all Ihre Fragen.",
    advancedAi: "Fortschrittliche KI-Krypto-Intelligenz",
    quoteText: "Für den durchschnittlichen, alltäglichen Menschen, der nach modernen Wegen sucht, sein Vermögen zu beschleunigen!",
    riskDisclaimer: "Der Kryptomarkt birgt erhebliche Risiken und ist nicht für jeden geeignet. Durch die Nutzung von Polar Tensor verstehen Sie diese Risiken und es werden keinerlei Garantien angeboten. Sie sind für Ihre eigene Sorgfaltspflicht und Ihr Beteiligungsniveau verantwortlich.",
  },
  es: {
    selectLanguage: "Selecciona tu idioma",
    nextLevel: "Siguiente Nivel",
    marketIntelligence: "Inteligencia de Mercado",
    heroSubtitle: "Construyendo un mañana más transparente y próspero en el espacio cripto.",
    startTradingNow: "Empieza a Operar Ahora",
    founderCeo: "Fundador y CEO",
    felixBio1: "Nacido en Hamburgo, Alemania, Felix comenzó su carrera en banca privada, donde desarrolló una pasión por el comercio internacional.",
    felixBio2: "Eventualmente, su fascinación por los patrones y la eficiencia, combinada con su interés en las criptomonedas, lo llevó a él y a su equipo a comenzar a desarrollar software de trading algorítmico.",
    felixBio3: "¡Hoy el software Polar One ha sido exitoso durante casi cuatro años!",
    felixQuote: "\"¡Somos una empresa que hace las cosas bien!\"",
    fullPresentation: "Presentación Completa",
    presentationSubtitle: "Descripción completa de nuestra plataforma y tecnología",
    softwareTitle: "Software y Rendimiento de Polar One",
    softwareSubtitle: "Mira cómo funciona nuestro sistema de trading con IA",
    marketingTitle: "Plan de Marketing y Recompensas",
    marketingSubtitle: "Descubre cómo puedes crecer con Polar Tensor",
    watchNow: "Ver Ahora",
    ctaTitle: "Comienza con Polar Tensor Hoy",
    enrollNow: "Inscríbete Ahora",
    stillNotReady: "¿Aún no estás listo para inscribirte?",
    shootMessage: "Envíame un mensaje y responderé todas tus preguntas.",
    advancedAi: "Inteligencia Cripto Avanzada con IA",
    quoteText: "¡Para la persona promedio, cotidiana, que busca formas modernas de acelerar su riqueza!",
    riskDisclaimer: "El mercado cripto implica riesgos significativos y no es adecuado para todos. Al interactuar con Polar Tensor, comprendes estos riesgos y no se ofrecen garantías de ningún tipo. Eres responsable de tu propia diligencia debida y nivel de participación.",
  },
  pt: {
    selectLanguage: "Selecione seu idioma",
    nextLevel: "Próximo Nível",
    marketIntelligence: "Inteligência de Mercado",
    heroSubtitle: "Construindo um amanhã mais transparente e próspero no espaço cripto.",
    startTradingNow: "Comece a Negociar Agora",
    founderCeo: "Fundador e CEO",
    felixBio1: "Nascido em Hamburgo, Alemanha, Felix começou sua carreira em banco privado, onde desenvolveu uma paixão pelo comércio internacional.",
    felixBio2: "Eventualmente, sua fascinação por padrões e eficiência, combinada com seu interesse em cripto, levou ele e sua equipe a começar a desenvolver software de trading algorítmico.",
    felixBio3: "Hoje o software Polar One tem sido bem-sucedido há quase quatro anos!",
    felixQuote: "\"Somos uma empresa que faz as coisas certas!\"",
    fullPresentation: "Apresentação Completa",
    presentationSubtitle: "Visão geral completa da nossa plataforma e tecnologia",
    softwareTitle: "Software e Desempenho Polar One",
    softwareSubtitle: "Veja como nosso sistema de trading com IA funciona",
    marketingTitle: "Plano de Marketing e Recompensas",
    marketingSubtitle: "Descubra como você pode crescer com a Polar Tensor",
    watchNow: "Assistir Agora",
    ctaTitle: "Comece com a Polar Tensor Hoje",
    enrollNow: "Inscreva-se Agora",
    stillNotReady: "Ainda não está pronto para se inscrever?",
    shootMessage: "Envie-me uma mensagem e responderei todas as suas perguntas.",
    advancedAi: "Inteligência Cripto Avançada com IA",
    quoteText: "Para a pessoa comum, do dia a dia, procurando formas modernas de acelerar sua riqueza!",
    riskDisclaimer: "O mercado cripto envolve riscos significativos e não é adequado para todos. Ao interagir com a Polar Tensor, você entende esses riscos e não são oferecidas garantias de nenhum tipo. Você é responsável pela sua própria diligência e nível de participação.",
  },
  ru: {
    selectLanguage: "Выберите ваш язык",
    nextLevel: "Следующий Уровень",
    marketIntelligence: "Рыночная Аналитика",
    heroSubtitle: "Строим более прозрачное и процветающее завтра в крипто-пространстве.",
    startTradingNow: "Начать Торговлю",
    founderCeo: "Основатель и CEO",
    felixBio1: "Родившийся в Гамбурге, Германия, Феликс начал свою карьеру в частном банкинге, где у него развилась страсть к международной торговле.",
    felixBio2: "В конце концов, его увлечение паттернами и эффективностью, в сочетании с интересом к криптовалютам, привело его и его команду к разработке алгоритмического торгового программного обеспечения.",
    felixBio3: "Сегодня программное обеспечение Polar One успешно работает уже почти четыре года!",
    felixQuote: "\"Мы компания, которая делает всё правильно!\"",
    fullPresentation: "Полная Презентация",
    presentationSubtitle: "Полный обзор нашей платформы и технологии",
    softwareTitle: "ПО Polar One и Производительность",
    softwareSubtitle: "Посмотрите, как работает наша торговая система с ИИ",
    marketingTitle: "Маркетинг и План Вознаграждений",
    marketingSubtitle: "Узнайте, как вы можете расти с Polar Tensor",
    watchNow: "Смотреть",
    ctaTitle: "Начните с Polar Tensor сегодня",
    enrollNow: "Зарегистрироваться",
    stillNotReady: "Ещё не готовы зарегистрироваться?",
    shootMessage: "Напишите мне, и я отвечу на все ваши вопросы.",
    advancedAi: "Продвинутый ИИ Крипто-Интеллект",
    quoteText: "Для обычного, повседневного человека, ищущего современные способы приумножить своё богатство!",
    riskDisclaimer: "Крипторынок сопряжён со значительными рисками и подходит не всем. Взаимодействуя с Polar Tensor, вы понимаете эти риски, и никаких гарантий не предоставляется. Вы несёте ответственность за собственную проверку и уровень участия.",
  },
  pl: {
    selectLanguage: "Wybierz swój język",
    nextLevel: "Następny Poziom",
    marketIntelligence: "Inteligencja Rynkowa",
    heroSubtitle: "Budujemy bardziej przejrzyste i dostatnie jutro w przestrzeni krypto.",
    startTradingNow: "Zacznij Handlować",
    founderCeo: "Założyciel i CEO",
    felixBio1: "Urodzony w Hamburgu w Niemczech, Felix rozpoczął karierę w bankowości prywatnej, gdzie rozwinął pasję do handlu międzynarodowego.",
    felixBio2: "Z czasem jego fascynacja wzorcami i wydajnością, w połączeniu z zainteresowaniem kryptowalutami, skłoniła go i jego zespół do rozpoczęcia tworzenia algorytmicznego oprogramowania handlowego.",
    felixBio3: "Dziś oprogramowanie Polar One odnosi sukcesy od prawie czterech lat!",
    felixQuote: "\"Jesteśmy firmą, która robi rzeczy dobrze!\"",
    fullPresentation: "Pełna Prezentacja",
    presentationSubtitle: "Kompletny przegląd naszej platformy i technologii",
    softwareTitle: "Oprogramowanie i Wydajność Polar One",
    softwareSubtitle: "Zobacz, jak działa nasz system handlu AI",
    marketingTitle: "Plan Marketingowy i Nagród",
    marketingSubtitle: "Odkryj, jak możesz rosnąć z Polar Tensor",
    watchNow: "Obejrzyj",
    ctaTitle: "Zacznij z Polar Tensor już dziś",
    enrollNow: "Zapisz się",
    stillNotReady: "Jeszcze nie jesteś gotowy, aby się zapisać?",
    shootMessage: "Napisz do mnie, a odpowiem na wszystkie Twoje pytania.",
    advancedAi: "Zaawansowana Inteligencja Krypto AI",
    quoteText: "Dla przeciętnego, codziennego człowieka, szukającego nowoczesnych sposobów na przyspieszenie swojego bogactwa!",
    riskDisclaimer: "Rynek kryptowalut wiąże się ze znacznym ryzykiem i nie jest odpowiedni dla wszystkich. Korzystając z Polar Tensor, rozumiesz te ryzyka i nie są oferowane żadne gwarancje. Jesteś odpowiedzialny za własną należytą staranność i poziom uczestnictwa.",
  },
  fr: {
    selectLanguage: "Sélectionnez votre langue",
    nextLevel: "Niveau Supérieur",
    marketIntelligence: "Intelligence de Marché",
    heroSubtitle: "Construire un avenir plus transparent et prospère dans l'espace crypto.",
    startTradingNow: "Commencer à Trader",
    founderCeo: "Fondateur et CEO",
    felixBio1: "Né à Hambourg, en Allemagne, Felix a commencé sa carrière dans la banque privée, où il a développé une passion pour le commerce international.",
    felixBio2: "Finalement, sa fascination pour les modèles et l'efficacité, combinée à son intérêt pour la crypto, l'a conduit, lui et son équipe, à développer un logiciel de trading algorithmique.",
    felixBio3: "Aujourd'hui, le logiciel Polar One connaît le succès depuis près de quatre ans !",
    felixQuote: "\"Nous sommes une entreprise qui fait les choses correctement !\"",
    fullPresentation: "Présentation Complète",
    presentationSubtitle: "Aperçu complet de notre plateforme et de notre technologie",
    softwareTitle: "Logiciel et Performance Polar One",
    softwareSubtitle: "Découvrez comment fonctionne notre système de trading IA",
    marketingTitle: "Plan Marketing et Récompenses",
    marketingSubtitle: "Découvrez comment vous pouvez grandir avec Polar Tensor",
    watchNow: "Regarder",
    ctaTitle: "Commencez avec Polar Tensor aujourd'hui",
    enrollNow: "S'inscrire",
    stillNotReady: "Pas encore prêt à vous inscrire ?",
    shootMessage: "Envoyez-moi un message et je répondrai à toutes vos questions.",
    advancedAi: "Intelligence Crypto IA Avancée",
    quoteText: "Pour la personne moyenne, au quotidien, cherchant des moyens modernes d'accélérer sa richesse !",
    riskDisclaimer: "Le marché crypto comporte des risques importants et ne convient pas à tout le monde. En utilisant Polar Tensor, vous comprenez ces risques et aucune garantie n'est offerte. Vous êtes responsable de votre propre diligence raisonnable et de votre niveau de participation.",
  },
  zh: {
    selectLanguage: "选择您的语言",
    nextLevel: "下一层次",
    marketIntelligence: "市场情报",
    heroSubtitle: "在加密货币领域构建更透明、更繁荣的未来。",
    startTradingNow: "立即开始交易",
    founderCeo: "创始人兼CEO",
    felixBio1: "Felix出生于德国汉堡，在私人银行业开始了他的职业生涯，并在那里培养了对国际贸易的热情。",
    felixBio2: "最终，他对模式和效率的迷恋，加上对加密货币的兴趣，促使他和他的团队开始开发算法交易软件。",
    felixBio3: "如今，Polar One软件已经成功运营了近四年！",
    felixQuote: "\"我们是一家做正确事情的公司！\"",
    fullPresentation: "完整演示",
    presentationSubtitle: "我们平台和技术的完整概述",
    softwareTitle: "Polar One 软件与表现",
    softwareSubtitle: "观看我们的AI交易系统如何运作",
    marketingTitle: "营销与奖励计划",
    marketingSubtitle: "了解如何与Polar Tensor一起成长",
    watchNow: "立即观看",
    ctaTitle: "今天就开始使用Polar Tensor",
    enrollNow: "立即注册",
    stillNotReady: "还没准备好注册？",
    shootMessage: "给我发消息，我会回答你所有的问题。",
    advancedAi: "先进AI加密情报",
    quoteText: "为普通人寻找加速财富增长的现代方式！",
    riskDisclaimer: "加密市场涉及重大风险，并非适合所有人。使用Polar Tensor即表示您理解这些风险，且不提供任何形式的保证。您需要对自己的尽职调查和参与程度负责。",
  },
  hi: {
    selectLanguage: "अपनी भाषा चुनें",
    nextLevel: "अगला स्तर",
    marketIntelligence: "बाजार बुद्धिमत्ता",
    heroSubtitle: "क्रिप्टो क्षेत्र में अधिक पारदर्शी और समृद्ध कल का निर्माण।",
    startTradingNow: "अभी ट्रेडिंग शुरू करें",
    founderCeo: "संस्थापक और CEO",
    felixBio1: "जर्मनी के हैम्बर्ग में जन्मे, फेलिक्स ने अपना करियर निजी बैंकिंग में शुरू किया, जहां उन्होंने अंतरराष्ट्रीय व्यापार के प्रति जुनून विकसित किया।",
    felixBio2: "अंततः, पैटर्न और दक्षता के प्रति उनके आकर्षण, क्रिप्टो में उनकी रुचि के साथ, उन्हें और उनकी टीम को एल्गोरिदमिक ट्रेडिंग सॉफ्टवेयर विकसित करने के लिए प्रेरित किया।",
    felixBio3: "आज Polar One सॉफ्टवेयर लगभग चार वर्षों से सफल है!",
    felixQuote: "\"हम एक ऐसी कंपनी हैं जो चीजें सही तरीके से करती है!\"",
    fullPresentation: "पूर्ण प्रस्तुति",
    presentationSubtitle: "हमारे प्लेटफॉर्म और तकनीक का पूरा अवलोकन",
    softwareTitle: "Polar One सॉफ्टवेयर और प्रदर्शन",
    softwareSubtitle: "देखें हमारा AI ट्रेडिंग सिस्टम कैसे काम करता है",
    marketingTitle: "मार्केटिंग और पुरस्कार योजना",
    marketingSubtitle: "जानें कि आप Polar Tensor के साथ कैसे बढ़ सकते हैं",
    watchNow: "अभी देखें",
    ctaTitle: "आज ही Polar Tensor के साथ शुरुआत करें",
    enrollNow: "अभी नामांकन करें",
    stillNotReady: "अभी भी नामांकन के लिए तैयार नहीं?",
    shootMessage: "मुझे एक संदेश भेजें और मैं आपके सभी सवालों का जवाब दूंगा।",
    advancedAi: "उन्नत AI क्रिप्टो बुद्धिमत्ता",
    quoteText: "औसत, रोज़मर्रा के व्यक्ति के लिए, जो अपनी संपत्ति बढ़ाने के आधुनिक तरीके खोज रहे हैं!",
    riskDisclaimer: "क्रिप्टो बाजार में महत्वपूर्ण जोखिम शामिल हैं और यह सभी के लिए उपयुक्त नहीं है। Polar Tensor के साथ जुड़कर, आप इन जोखिमों को समझते हैं और किसी भी प्रकार की कोई गारंटी नहीं दी जाती है। आप अपनी स्वयं की उचित जांच और भागीदारी स्तर के लिए जिम्मेदार हैं।",
  },
  th: {
    selectLanguage: "เลือกภาษาของคุณ",
    nextLevel: "ระดับถัดไป",
    marketIntelligence: "ข่าวกรองตลาด",
    heroSubtitle: "สร้างวันพรุ่งนี้ที่โปร่งใสและเจริญรุ่งเรืองยิ่งขึ้นในพื้นที่คริปโต",
    startTradingNow: "เริ่มเทรดตอนนี้",
    founderCeo: "ผู้ก่อตั้งและ CEO",
    felixBio1: "เกิดที่ฮัมบูร์ก ประเทศเยอรมนี เฟลิกซ์เริ่มต้นอาชีพในธนาคารเอกชน ซึ่งเขาพัฒนาความหลงใหลในการค้าระหว่างประเทศ",
    felixBio2: "ในที่สุด ความหลงใหลในรูปแบบและประสิทธิภาพ ร่วมกับความสนใจในคริปโต ทำให้เขาและทีมเริ่มพัฒนาซอฟต์แวร์การเทรดอัลกอริทึม",
    felixBio3: "วันนี้ซอฟต์แวร์ Polar One ประสบความสำเร็จมาเกือบสี่ปีแล้ว!",
    felixQuote: "\"เราเป็นบริษัทที่ทำสิ่งต่างๆ อย่างถูกต้อง!\"",
    fullPresentation: "การนำเสนอเต็มรูปแบบ",
    presentationSubtitle: "ภาพรวมที่สมบูรณ์ของแพลตฟอร์มและเทคโนโลยีของเรา",
    softwareTitle: "ซอฟต์แวร์และประสิทธิภาพ Polar One",
    softwareSubtitle: "ชมการทำงานของระบบเทรด AI ของเรา",
    marketingTitle: "แผนการตลาดและรางวัล",
    marketingSubtitle: "ค้นพบว่าคุณจะเติบโตกับ Polar Tensor ได้อย่างไร",
    watchNow: "ดูตอนนี้",
    ctaTitle: "เริ่มต้นกับ Polar Tensor วันนี้",
    enrollNow: "ลงทะเบียนตอนนี้",
    stillNotReady: "ยังไม่พร้อมลงทะเบียน?",
    shootMessage: "ส่งข้อความถึงฉัน แล้วฉันจะตอบคำถามทั้งหมดของคุณ",
    advancedAi: "AI คริปโตอัจฉริยะขั้นสูง",
    quoteText: "สำหรับคนทั่วไป ที่มองหาวิธีสมัยใหม่ในการเร่งความมั่งคั่ง!",
    riskDisclaimer: "ตลาดคริปโตมีความเสี่ยงสูง และไม่เหมาะสำหรับทุกคน การใช้ Polar Tensor แสดงว่าคุณเข้าใจความเสี่ยงเหล่านี้ และไม่มีการรับประกันใดๆ คุณรับผิดชอบต่อการตรวจสอบและระดับการมีส่วนร่วมของคุณเอง",
  },
  vi: {
    selectLanguage: "Chọn ngôn ngữ của bạn",
    nextLevel: "Cấp Độ Tiếp Theo",
    marketIntelligence: "Thông Tin Thị Trường",
    heroSubtitle: "Xây dựng ngày mai minh bạch và thịnh vượng hơn trong không gian crypto.",
    startTradingNow: "Bắt Đầu Giao Dịch",
    founderCeo: "Nhà Sáng Lập & CEO",
    felixBio1: "Sinh ra tại Hamburg, Đức, Felix bắt đầu sự nghiệp trong ngân hàng tư nhân, nơi anh phát triển niềm đam mê thương mại quốc tế.",
    felixBio2: "Cuối cùng, sự say mê với các mô hình và hiệu quả, kết hợp với sự quan tâm đến crypto, đã dẫn dắt anh và đội của mình bắt đầu phát triển phần mềm giao dịch thuật toán.",
    felixBio3: "Ngày nay phần mềm Polar One đã thành công gần bốn năm!",
    felixQuote: "\"Chúng tôi là công ty làm đúng mọi việc!\"",
    fullPresentation: "Bài Thuyết Trình Đầy Đủ",
    presentationSubtitle: "Tổng quan đầy đủ về nền tảng và công nghệ của chúng tôi",
    softwareTitle: "Phần Mềm & Hiệu Suất Polar One",
    softwareSubtitle: "Xem hệ thống giao dịch AI của chúng tôi hoạt động",
    marketingTitle: "Kế Hoạch Marketing & Phần Thưởng",
    marketingSubtitle: "Khám phá cách bạn có thể phát triển cùng Polar Tensor",
    watchNow: "Xem Ngay",
    ctaTitle: "Bắt Đầu Với Polar Tensor Hôm Nay",
    enrollNow: "Đăng Ký Ngay",
    stillNotReady: "Vẫn chưa sẵn sàng đăng ký?",
    shootMessage: "Gửi cho tôi tin nhắn và tôi sẽ trả lời tất cả câu hỏi của bạn.",
    advancedAi: "Trí Tuệ Crypto AI Tiên Tiến",
    quoteText: "Dành cho người bình thường, hàng ngày, tìm kiếm những cách hiện đại để tăng tốc tài sản!",
    riskDisclaimer: "Thị trường crypto liên quan đến rủi ro đáng kể và không phù hợp với tất cả mọi người. Khi tham gia Polar Tensor, bạn hiểu những rủi ro này và không có bảo đảm nào được cung cấp. Bạn chịu trách nhiệm về sự thẩm định và mức độ tham gia của riêng mình.",
  },
  id: {
    selectLanguage: "Pilih bahasa Anda",
    nextLevel: "Level Berikutnya",
    marketIntelligence: "Intelijen Pasar",
    heroSubtitle: "Membangun hari esok yang lebih transparan dan makmur di ruang kripto.",
    startTradingNow: "Mulai Trading Sekarang",
    founderCeo: "Pendiri & CEO",
    felixBio1: "Lahir di Hamburg, Jerman, Felix memulai karirnya di perbankan swasta, di mana ia mengembangkan hasrat untuk perdagangan internasional.",
    felixBio2: "Akhirnya, ketertarikannya pada pola dan efisiensi, dikombinasikan dengan minatnya pada kripto, membawanya dan timnya untuk mulai mengembangkan perangkat lunak trading algoritmik.",
    felixBio3: "Hari ini perangkat lunak Polar One telah sukses selama hampir empat tahun!",
    felixQuote: "\"Kami adalah perusahaan yang melakukan hal-hal dengan benar!\"",
    fullPresentation: "Presentasi Lengkap",
    presentationSubtitle: "Gambaran lengkap platform dan teknologi kami",
    softwareTitle: "Perangkat Lunak & Kinerja Polar One",
    softwareSubtitle: "Saksikan cara kerja sistem trading AI kami",
    marketingTitle: "Rencana Pemasaran & Hadiah",
    marketingSubtitle: "Temukan bagaimana Anda bisa tumbuh bersama Polar Tensor",
    watchNow: "Tonton Sekarang",
    ctaTitle: "Mulai Dengan Polar Tensor Hari Ini",
    enrollNow: "Daftar Sekarang",
    stillNotReady: "Masih belum siap untuk mendaftar?",
    shootMessage: "Kirim saya pesan dan saya akan menjawab semua pertanyaan Anda.",
    advancedAi: "Intelijen Kripto AI Canggih",
    quoteText: "Untuk orang biasa, sehari-hari, yang mencari cara modern untuk mempercepat kekayaan mereka!",
    riskDisclaimer: "Pasar kripto melibatkan risiko signifikan dan tidak cocok untuk semua orang. Dengan menggunakan Polar Tensor, Anda memahami risiko ini dan tidak ada jaminan yang ditawarkan. Anda bertanggung jawab atas uji tuntas dan tingkat partisipasi Anda sendiri.",
  },
  ja: {
    selectLanguage: "言語を選択してください",
    nextLevel: "次のレベル",
    marketIntelligence: "マーケットインテリジェンス",
    heroSubtitle: "暗号通貨空間において、より透明で繁栄した明日を構築します。",
    startTradingNow: "今すぐ取引を開始",
    founderCeo: "創設者兼CEO",
    felixBio1: "ドイツのハンブルクに生まれたフェリックスは、プライベートバンキングでキャリアをスタートし、国際貿易への情熱を育みました。",
    felixBio2: "やがて、パターンと効率性への魅力が、暗号通貨への関心と相まって、彼とチームをアルゴリズム取引ソフトウェアの開発へと導きました。",
    felixBio3: "今日、Polar Oneソフトウェアは約4年間成功を収めています！",
    felixQuote: "\"私たちは正しいことをする会社です！\"",
    fullPresentation: "フルプレゼンテーション",
    presentationSubtitle: "プラットフォームとテクノロジーの完全な概要",
    softwareTitle: "Polar One ソフトウェアとパフォーマンス",
    softwareSubtitle: "AIトレーディングシステムの動作をご覧ください",
    marketingTitle: "マーケティング＆リワードプラン",
    marketingSubtitle: "Polar Tensorでどのように成長できるかを発見してください",
    watchNow: "今すぐ視聴",
    ctaTitle: "今日からPolar Tensorを始めましょう",
    enrollNow: "今すぐ登録",
    stillNotReady: "まだ登録する準備ができていませんか？",
    shootMessage: "メッセージを送ってください。すべての質問にお答えします。",
    advancedAi: "先進的AIクリプトインテリジェンス",
    quoteText: "日常の一般的な方へ、富を加速させる現代的な方法を探しているあなたへ！",
    riskDisclaimer: "暗号通貨市場には重大なリスクが伴い、すべての人に適しているわけではありません。Polar Tensorを利用することで、これらのリスクを理解し、いかなる保証も提供されないことに同意します。ご自身のデューデリジェンスと参加レベルについて責任を負います。",
  },
  bs: {
    selectLanguage: "Odaberite svoj jezik",
    nextLevel: "Sljedeći Nivo",
    marketIntelligence: "Tržišna Inteligencija",
    heroSubtitle: "Gradimo transparentnije i prosperitetnije sutra u kripto prostoru.",
    startTradingNow: "Počni Trgovati",
    founderCeo: "Osnivač i CEO",
    felixBio1: "Rođen u Hamburgu, Njemačka, Felix je započeo karijeru u privatnom bankarstvu, gdje je razvio strast za međunarodnu trgovinu.",
    felixBio2: "Na kraju, njegova fascinacija obrascima i efikasnošću, u kombinaciji s interesom za kripto, dovela je njega i njegov tim da počnu razvijati algoritmički softver za trgovanje.",
    felixBio3: "Danas je Polar One softver uspješan već skoro četiri godine!",
    felixQuote: "\"Mi smo kompanija koja radi stvari ispravno!\"",
    fullPresentation: "Kompletna Prezentacija",
    presentationSubtitle: "Potpuni pregled naše platforme i tehnologije",
    softwareTitle: "Polar One Softver i Performanse",
    softwareSubtitle: "Pogledajte kako funkcioniše naš AI sistem za trgovanje",
    marketingTitle: "Marketing i Plan Nagrada",
    marketingSubtitle: "Otkrijte kako možete rasti sa Polar Tensorom",
    watchNow: "Gledaj Sada",
    ctaTitle: "Započnite sa Polar Tensorom danas",
    enrollNow: "Registruj Se",
    stillNotReady: "Još uvijek niste spremni za registraciju?",
    shootMessage: "Pošaljite mi poruku i odgovoriću na sva vaša pitanja.",
    advancedAi: "Napredna AI Kripto Inteligencija",
    quoteText: "Za prosječnu, svakodnevnu osobu, koja traži moderne načine da ubrza svoje bogatstvo!",
    riskDisclaimer: "Kripto tržište uključuje značajne rizike i nije pogodno za svakoga. Korištenjem Polar Tensora, razumijete ove rizike i ne nude se nikakve garancije. Odgovorni ste za vlastitu dužnu pažnju i nivo učešća.",
  },
  hu: {
    selectLanguage: "Válassza ki a nyelvét",
    nextLevel: "Következő Szint",
    marketIntelligence: "Piaci Intelligencia",
    heroSubtitle: "Átláthatóbb és virágzóbb holnapot építünk a kripto térben.",
    startTradingNow: "Kezdj El Kereskedni",
    founderCeo: "Alapító és CEO",
    felixBio1: "A németországi Hamburgban született Felix a magánbanki szektorban kezdte pályafutását, ahol kifejlesztette szenvedélyét a nemzetközi kereskedelem iránt.",
    felixBio2: "Végül a minták és a hatékonyság iránti lenyűgözöttsége, kombinálva a kriptovaluták iránti érdeklődésével, arra vezette őt és csapatát, hogy algoritmikus kereskedési szoftvert fejlesszenek.",
    felixBio3: "Ma a Polar One szoftver közel négy éve sikeres!",
    felixQuote: "\"Mi egy olyan cég vagyunk, amely helyesen csinálja a dolgokat!\"",
    fullPresentation: "Teljes Prezentáció",
    presentationSubtitle: "Platformunk és technológiánk teljes áttekintése",
    softwareTitle: "Polar One Szoftver és Teljesítmény",
    softwareSubtitle: "Nézze meg, hogyan működik AI kereskedési rendszerünk",
    marketingTitle: "Marketing és Jutalom Terv",
    marketingSubtitle: "Fedezze fel, hogyan növekedhet a Polar Tensorral",
    watchNow: "Nézd Meg",
    ctaTitle: "Kezdjen a Polar Tensorral még ma",
    enrollNow: "Regisztrálj Most",
    stillNotReady: "Még nem áll készen a regisztrációra?",
    shootMessage: "Küldjön nekem egy üzenetet, és megválaszolom az összes kérdését.",
    advancedAi: "Fejlett AI Kripto Intelligencia",
    quoteText: "Az átlagos, mindennapi ember számára, aki modern módokat keres vagyona gyarapítására!",
    riskDisclaimer: "A kripto piac jelentős kockázatokkal jár, és nem mindenki számára alkalmas. A Polar Tensor használatával megérti ezeket a kockázatokat, és semmilyen garancia nem kerül felajánlásra. Ön felelős a saját átvilágításáért és részvételi szintjéért.",
  },
  hr: {
    selectLanguage: "Odaberite svoj jezik",
    nextLevel: "Sljedeća Razina",
    marketIntelligence: "Tržišna Inteligencija",
    heroSubtitle: "Gradimo transparentnije i prosperitetnije sutra u kripto prostoru.",
    startTradingNow: "Počni Trgovati",
    founderCeo: "Osnivač i CEO",
    felixBio1: "Rođen u Hamburgu, Njemačka, Felix je započeo karijeru u privatnom bankarstvu, gdje je razvio strast za međunarodnu trgovinu.",
    felixBio2: "Na kraju, njegova fascinacija uzorcima i učinkovitošću, u kombinaciji s interesom za kripto, dovela je njega i njegov tim do razvoja algoritamskog softvera za trgovanje.",
    felixBio3: "Danas je Polar One softver uspješan već gotovo četiri godine!",
    felixQuote: "\"Mi smo tvrtka koja radi stvari ispravno!\"",
    fullPresentation: "Potpuna Prezentacija",
    presentationSubtitle: "Potpuni pregled naše platforme i tehnologije",
    softwareTitle: "Polar One Softver i Performanse",
    softwareSubtitle: "Pogledajte kako funkcionira naš AI sustav za trgovanje",
    marketingTitle: "Marketing i Plan Nagrada",
    marketingSubtitle: "Otkrijte kako možete rasti s Polar Tensorom",
    watchNow: "Gledaj Sada",
    ctaTitle: "Započnite s Polar Tensorom danas",
    enrollNow: "Registriraj Se",
    stillNotReady: "Još niste spremni za registraciju?",
    shootMessage: "Pošaljite mi poruku i odgovorit ću na sva vaša pitanja.",
    advancedAi: "Napredna AI Kripto Inteligencija",
    quoteText: "Za prosječnu, svakodnevnu osobu, koja traži moderne načine za ubrzanje svog bogatstva!",
    riskDisclaimer: "Kripto tržište uključuje značajne rizike i nije pogodno za sve. Korištenjem Polar Tensora, razumijete ove rizike i ne nude se nikakva jamstva. Odgovorni ste za vlastitu dužnu pažnju i razinu sudjelovanja.",
  },
  sr: {
    selectLanguage: "Изаберите свој језик",
    nextLevel: "Следећи Ниво",
    marketIntelligence: "Тржишна Интелигенција",
    heroSubtitle: "Градимо транспарентније и просперитетније сутра у крипто простору.",
    startTradingNow: "Почни да Тргујеш",
    founderCeo: "Оснивач и CEO",
    felixBio1: "Рођен у Хамбургу, Немачка, Феликс је започео каријеру у приватном банкарству, где је развио страст за међународну трговину.",
    felixBio2: "На крају, његова фасцинација обрасцима и ефикасношћу, у комбинацији са интересом за крипто, довела је њега и његов тим да почну да развијају алгоритамски софтвер за трговање.",
    felixBio3: "Данас је Polar One софтвер успешан већ скоро четири године!",
    felixQuote: "\"Ми смо компанија која ради ствари исправно!\"",
    fullPresentation: "Комплетна Презентација",
    presentationSubtitle: "Потпуни преглед наше платформе и технологије",
    softwareTitle: "Polar One Софтвер и Перформансе",
    softwareSubtitle: "Погледајте како функционише наш АИ систем за трговање",
    marketingTitle: "Маркетинг и План Награда",
    marketingSubtitle: "Откријте како можете расти са Polar Тензором",
    watchNow: "Гледај Сада",
    ctaTitle: "Започните са Polar Тензором данас",
    enrollNow: "Региструј Се",
    stillNotReady: "Још увек нисте спремни за регистрацију?",
    shootMessage: "Пошаљите ми поруку и одговорићу на сва ваша питања.",
    advancedAi: "Напредна АИ Крипто Интелигенција",
    quoteText: "За просечну, свакодневну особу, која тражи модерне начине да убрза своје богатство!",
    riskDisclaimer: "Крипто тржиште укључује значајне ризике и није погодно за свакога. Коришћењем Polar Тензора, разумете ове ризике и не нуде се никакве гаранције. Одговорни сте за сопствену дужну пажњу и ниво учешћа.",
  },
  it: {
    selectLanguage: "Seleziona la tua lingua",
    nextLevel: "Livello Successivo",
    marketIntelligence: "Intelligenza di Mercato",
    heroSubtitle: "Costruire un domani più trasparente e prospero nello spazio crypto.",
    startTradingNow: "Inizia a Fare Trading",
    founderCeo: "Fondatore e CEO",
    felixBio1: "Nato ad Amburgo, in Germania, Felix ha iniziato la sua carriera nel private banking, dove ha sviluppato una passione per il commercio internazionale.",
    felixBio2: "Alla fine, il suo fascino per i pattern e l'efficienza, combinato con il suo interesse per le crypto, ha portato lui e il suo team a sviluppare software di trading algoritmico.",
    felixBio3: "Oggi il software Polar One ha avuto successo per quasi quattro anni!",
    felixQuote: "\"Siamo un'azienda che fa le cose nel modo giusto!\"",
    fullPresentation: "Presentazione Completa",
    presentationSubtitle: "Panoramica completa della nostra piattaforma e tecnologia",
    softwareTitle: "Software e Performance Polar One",
    softwareSubtitle: "Guarda come funziona il nostro sistema di trading AI",
    marketingTitle: "Piano Marketing e Ricompense",
    marketingSubtitle: "Scopri come puoi crescere con Polar Tensor",
    watchNow: "Guarda Ora",
    ctaTitle: "Inizia con Polar Tensor Oggi",
    enrollNow: "Iscriviti Ora",
    stillNotReady: "Non sei ancora pronto per iscriverti?",
    shootMessage: "Inviami un messaggio e risponderò a tutte le tue domande.",
    advancedAi: "Intelligenza Crypto AI Avanzata",
    quoteText: "Per la persona media, di tutti i giorni, che cerca modi moderni per accelerare la propria ricchezza!",
    riskDisclaimer: "Il mercato crypto comporta rischi significativi e non è adatto a tutti. Utilizzando Polar Tensor, comprendi questi rischi e non vengono offerte garanzie di alcun tipo. Sei responsabile della tua due diligence e del tuo livello di partecipazione.",
  },
  ro: {
    selectLanguage: "Selectează limba",
    nextLevel: "Nivelul Următor",
    marketIntelligence: "Inteligență de Piață",
    heroSubtitle: "Construim un mâine mai transparent și mai prosper în spațiul crypto.",
    startTradingNow: "Începe Trading-ul Acum",
    founderCeo: "Fondator și CEO",
    felixBio1: "Născut în Hamburg, Germania, Felix și-a început cariera în banca privată, unde și-a dezvoltat pasiunea pentru comerțul internațional.",
    felixBio2: "În cele din urmă, fascinația sa pentru tipare și eficiență, combinată cu interesul său pentru crypto, l-a determinat pe el și echipa sa să înceapă dezvoltarea unui software de trading algoritmic.",
    felixBio3: "Astăzi software-ul Polar One are succes de aproape patru ani!",
    felixQuote: "\"Suntem o companie care face lucrurile cum trebuie!\"",
    fullPresentation: "Prezentare Completă",
    presentationSubtitle: "Prezentare completă a platformei și tehnologiei noastre",
    softwareTitle: "Software și Performanță Polar One",
    softwareSubtitle: "Urmărește cum funcționează sistemul nostru de trading cu AI",
    marketingTitle: "Plan de Marketing și Recompense",
    marketingSubtitle: "Descoperă cum poți crește alături de Polar Tensor",
    watchNow: "Vezi Acum",
    ctaTitle: "Începe cu Polar Tensor Astăzi",
    enrollNow: "Înscrie-te Acum",
    stillNotReady: "Încă nu ești pregătit să te înscrii?",
    shootMessage: "Trimite-mi un mesaj și îți voi răspunde la toate întrebările.",
    advancedAi: "Inteligență Crypto AI Avansată",
    quoteText: "Pentru persoana obișnuită, de zi cu zi, care caută modalități moderne de a-și accelera averea!",
    riskDisclaimer: "Piața crypto implică riscuri semnificative și nu este potrivită pentru toată lumea. Utilizând Polar Tensor, înțelegi aceste riscuri și nu se oferă nicio garanție de niciun fel. Ești responsabil pentru propria diligență și nivelul tău de participare.",
  },
};
